import { useNavigate } from "react-router-dom";

import WarningInfoGreenIcon from '@/assets/icons/warning-info-green.svg';

import { CustomersController } from "../../endpoints/customers";
import { useAppDispatch, useAppSelector } from "../../hooks/store";
import { ABSOLUTE_ROUTES } from "../../constants/routes";
import { setEligibilityFailedModalOpen } from "@/store/slices/onboarding";
import { selectEligibilityFailedModalOpen } from "@/store/slices/onboarding/selectors";
import { Button, Modal } from "@/shared/ui";

const EligibilityFailedModal = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const eligibilityFailedModalOpen = useAppSelector(selectEligibilityFailedModalOpen);

    const onConfirm = () => {
        dispatch(setEligibilityFailedModalOpen(false));
        dispatch(CustomersController.logout());
    }

    const onCancel = () => {
        dispatch(setEligibilityFailedModalOpen(false));
        navigate(ABSOLUTE_ROUTES.ONBOARDING.INSURANCE.MAIN);
    }

    return (
        <Modal dataTestId="eligibility-failed" defaultPaddings={false} open={eligibilityFailedModalOpen} onClose={onCancel} hideCloseIcon={true} contentClassName="xl:max-w-[488px] p-5 sm:p-12">
            <div className="flex flex-col items-center justify-center" data-testid="eligibility-failed-container">
                <img
                    width={56}
                    className="w-[2.9375rem] h-[2.9375rem] mb-4 sm-max:w-9 sm-max:h-9 sm-max:mb-[0.4375rem] mb-1 sm-max:w-[48px]"
                    src={WarningInfoGreenIcon}
                    alt="warning"
                />

                <h3 className="mb-5 text-center font-agrandir text-[1.75rem] sm-max:text-[1.5625rem]">
                    Unfortunately, we don’t work with your insurance at this time, but we’ll notify you by email if that changes.
                </h3>

                <div className="flex w-full flex-col">
                    <Button
                        testId="button-eligibility-exit-account"
                        className='confirm_modal__confirm'
                        type="submit"
                        sx={{ width: '100%', marginBottom: '1rem', fontSize: '1.125rem' }}
                        onClick={onConfirm}
                        showEndIcon
                    >
                        <span>Exit Account</span>
                    </Button>
                    <Button
                        testId="button-eligibility-add-another"
                        className='confirm_modal__cancel'
                        sx={{ width: '100%', marginBottom: '1rem', fontSize: '1.125rem' }}
                        variant="outlined"
                        onClick={onCancel}
                    >
                        <span>Add Another Insurance</span>
                    </Button>
                    <Button
                        testId="button-eligibility-proceed"
                        className='confirm_modal__cancel'
                        sx={{ width: '100%', fontSize: '1.125rem' }}
                        variant="text"
                        onClick={onCancel}
                    >
                        <span>Proceed without Insurance</span>
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

export default EligibilityFailedModal;